import React, { useState } from 'react';
import { MobileLayout } from '../components/MobileLayout';
import { Calendar, CheckCircle, XCircle, Clock } from 'lucide-react';
import { Tabs } from '../components/ui/Tabs';
import { Card, CardContent } from '../components/ui/Card';
export function StoricoPage() {
  const [activeFilter, setActiveFilter] = useState<'Tutti' | 'Completati' | 'Annullati'>('Tutti');
  const historyItems = [{
    id: 1,
    date: '18 Gen 2024',
    time: '10:30',
    property: 'Villa Sunset',
    provider: 'CleanPro Services',
    status: 'Completato',
    type: 'Ordinaria',
    price: '€35,00'
  }, {
    id: 2,
    date: '17 Gen 2024',
    time: '14:00',
    property: 'Appartamento Centro',
    provider: 'LuxuryClean',
    status: 'Completato',
    type: 'Profonda',
    price: '€80,00'
  }, {
    id: 3,
    date: '15 Gen 2024',
    time: '09:00',
    property: 'Villa Sunset',
    provider: 'CleanPro Services',
    status: 'Completato',
    type: 'Ordinaria',
    price: '€35,00'
  }, {
    id: 4,
    date: '12 Gen 2024',
    time: '11:30',
    property: 'Appartamento Centro',
    provider: 'LuxuryClean',
    status: 'Annullato',
    type: 'Ordinaria',
    price: '€35,00'
  }, {
    id: 5,
    date: '10 Gen 2024',
    time: '10:00',
    property: 'Villa Sunset',
    provider: 'CleanPro Services',
    status: 'Completato',
    type: 'Ordinaria',
    price: '€35,00'
  }];
  const filteredItems = historyItems.filter(item => {
    if (activeFilter === 'Tutti') return true;
    if (activeFilter === 'Completati') return item.status === 'Completato';
    return item.status === 'Annullato';
  });
  return <MobileLayout data-id="element-4539">
      {/* Page Header */}
      <div className="mb-6 lg:mb-8" data-id="element-4540">
        <h1 className="text-xl lg:text-2xl font-bold text-navy" data-id="element-4541">Storico</h1>
      </div>

      {/* Summary Stats - MOVED TO TOP */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6" data-id="element-4542">
        <Card data-id="element-4543">
          <CardContent data-id="element-4544">
            <p className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-4545">
              Totale Interventi
            </p>
            <p className="text-2xl lg:text-3xl font-bold text-navy" data-id="element-4546">
              {historyItems.length}
            </p>
          </CardContent>
        </Card>
        <Card data-id="element-4547">
          <CardContent data-id="element-4548">
            <p className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-4549">
              Completati
            </p>
            <p className="text-2xl lg:text-3xl font-bold text-green-600" data-id="element-4550">
              {historyItems.filter(i => i.status === 'Completato').length}
            </p>
          </CardContent>
        </Card>
        <Card data-id="element-4551">
          <CardContent data-id="element-4552">
            <p className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-4553">
              Pulizie Effettuate
            </p>
            <p className="text-2xl lg:text-3xl font-bold text-coral" data-id="element-4554">
              {historyItems.filter(i => i.status === 'Completato' && (i.type === 'Ordinaria' || i.type === 'Profonda')).length}
            </p>
          </CardContent>
        </Card>
        <Card data-id="element-4555">
          <CardContent data-id="element-4556">
            <p className="text-xs text-gray-400 uppercase tracking-wider font-medium mb-1" data-id="element-4557">
              Spesa Totale
            </p>
            <p className="text-2xl lg:text-3xl font-bold text-navy" data-id="element-4558">€220,00</p>
          </CardContent>
        </Card>
      </div>

      {/* Filters - Pill tab style (same as Pulizie) */}
      <Tabs className="mb-6" scrollable value={activeFilter} onValueChange={id => setActiveFilter(id as 'Tutti' | 'Completati' | 'Annullati')} items={[{
      id: 'Tutti',
      label: 'Tutti'
    }, {
      id: 'Completati',
      label: 'Completati'
    }, {
      id: 'Annullati',
      label: 'Annullati'
    }]} data-id="element-4559" />

      {/* History List - Mobile: Cards, Desktop: Table */}
      <Card data-id="element-4560">
        {/* Mobile: Card Layout */}
        <div className="lg:hidden divide-y divide-gray-100" data-id="element-4561">
          {filteredItems.map(item => <div key={item.id} className="p-4 space-y-3" data-id="element-4562">
              <div className="flex items-start justify-between" data-id="element-4563">
                <div data-id="element-4564">
                  <p className="font-medium text-navy text-sm" data-id="element-4565">
                    {item.property}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-4566">
                    {item.date} • {item.time}
                  </p>
                </div>
                <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${item.status === 'Completato' ? 'bg-green-100 text-green-800' : item.status === 'Annullato' ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-600'}`} data-id="element-4567">
                  {item.status === 'Completato' && <CheckCircle size={12} data-id="element-4568" />}
                  {item.status === 'Annullato' && <XCircle size={12} data-id="element-4569" />}
                  {item.status}
                </span>
              </div>
              <div className="grid grid-cols-2 gap-2 text-xs" data-id="element-4570">
                <div data-id="element-4571">
                  <p className="text-gray-500" data-id="element-4572">Fornitore</p>
                  <p className="text-navy font-medium" data-id="element-4573">{item.provider}</p>
                </div>
                <div data-id="element-4574">
                  <p className="text-gray-500" data-id="element-4575">Tipo</p>
                  <p className="text-navy font-medium" data-id="element-4576">{item.type}</p>
                </div>
              </div>
              <div className="pt-2 border-t border-gray-100 flex items-center justify-between" data-id="element-4577">
                <p className="text-sm font-bold text-navy" data-id="element-4578">{item.price}</p>
                <button className="text-xs text-teal-deep hover:underline font-medium" data-id="element-4579">
                  Dettagli
                </button>
              </div>
            </div>)}
        </div>

        {/* Desktop: Table Layout */}
        <div className="hidden lg:block overflow-x-auto" data-id="element-4580">
          <table className="w-full text-sm" data-id="element-4581">
            <thead className="bg-gray-50 border-b border-gray-100" data-id="element-4582">
              <tr data-id="element-4583">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-4584">
                  Data
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-4585">
                  Proprietà
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-4586">
                  Fornitore
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-4587">
                  Tipo
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-4588">
                  Prezzo
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-4589">
                  Stato
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-4590">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-4591">
              {filteredItems.map(item => <tr key={item.id} className="hover:bg-gray-50" data-id="element-4592">
                  <td className="px-6 py-4 text-gray-600" data-id="element-4593">
                    {item.date}
                    <br data-id="element-4594" />
                    <span className="text-xs text-gray-400" data-id="element-4595">{item.time}</span>
                  </td>
                  <td className="px-6 py-4 font-medium text-navy" data-id="element-4596">
                    {item.property}
                  </td>
                  <td className="px-6 py-4 text-gray-600" data-id="element-4597">{item.provider}</td>
                  <td className="px-6 py-4 text-gray-600" data-id="element-4598">{item.type}</td>
                  <td className="px-6 py-4 font-medium text-navy" data-id="element-4599">
                    {item.price}
                  </td>
                  <td className="px-6 py-4" data-id="element-4600">
                    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${item.status === 'Completato' ? 'bg-green-100 text-green-800' : item.status === 'Annullato' ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-600'}`} data-id="element-4601">
                      {item.status === 'Completato' && <CheckCircle size={12} data-id="element-4602" />}
                      {item.status === 'Annullato' && <XCircle size={12} data-id="element-4603" />}
                      {item.status}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-4604">
                    <button className="text-sm text-teal-deep hover:underline font-medium" data-id="element-4605">
                      Dettagli
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </MobileLayout>;
}